var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FilterCollection from "~/components/collection-manage/all-case/filter-collection.vue";
import FollowAllQuery from "~/components/collection-manage/follow-all-query.vue";
import { Layout, Dependencies } from "~/core/decorator";
import { State, namespace, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { StatusConfigService } from "~/services/manage-service/status-config.service";
import NumberRange from "~/components/common/number-range.vue";
import { CaseCollectorService } from "~/services/business-service/case-collector.service";
import { CallApi } from "~/utils/call.api";
import { StorageService } from "~/utils/storage.service";
import { CollectionData } from "~/config/types/collection-data";
var collectionManageModule = namespace("collection-manage");
//@Auth(110)
var CollectionCase = /** @class */ (function (_super) {
    __extends(CollectionCase, _super);
    function CollectionCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false,
        };
        _this.queryParamsModel = {
            taskName: "",
            agent: "",
            principalId: "",
        };
        // 创建 XMLHttpRequest 对象
        _this.xhr = new XMLHttpRequest();
        _this.pageSize = 10;
        _this.pageIndex = 1;
        _this.total = 0;
        _this.selectionList = [];
        _this.dataSet = [];
        return _this;
    }
    CollectionCase.prototype.onRouteChange = function (val) {
        if (!val)
            return;
        this.handleResetForm();
        this.queryParamsModel.principalId = val.params.principalId;
        this.refreshData();
    };
    CollectionCase.prototype.mounted = function () {
    };
    CollectionCase.prototype.handleResetForm = function () {
        this.queryParamsModel.taskName = "";
        this.queryParamsModel.agent = "";
    };
    CollectionCase.prototype.handleSizeChange = function (val) {
        this.pageSize = val;
        this.refreshData();
    };
    CollectionCase.prototype.handleCurrentChange = function (val) {
        this.pageIndex = val;
        this.refreshData();
    };
    CollectionCase.prototype.filterStatus = function (value, row) {
        return row.runningStatusStr === value;
    };
    CollectionCase.prototype.getType = function (t) {
        if (t === "运行中") {
            return "success";
        }
        else if (t === "已暂停") {
            return "warning";
        }
        else if (t === "已停止") {
            return "danger";
        }
        else {
            return "primary";
        }
    };
    CollectionCase.prototype.refreshSelect = function (val) {
        this.selectionList = val;
        console.log(this.selectionList);
    };
    CollectionCase.prototype.refreshData = function () {
        var that = this;
        that.loading.state = true;
        var myObj = {
            agent: that.queryParamsModel.agent,
            taskName: that.queryParamsModel.taskName,
            pageIndex: that.pageIndex,
            pageSize: that.pageSize,
            clientId: that.queryParamsModel.principalId,
            customer: 'C284',
            createBy: StorageService.getItem("userInfoStage").username,
        };
        var url = CallApi.callTaskPageList(myObj);
        // 初始化 GET 请求
        that.xhr.open("GET", url, true);
        // 发送 GET 请求
        that.xhr.send();
        // 定义处理响应的回调函数
        that.xhr.onreadystatechange = function () {
            that.loading.state = false;
            if (that.xhr.readyState === XMLHttpRequest.DONE) {
                if (that.xhr.status === 200) {
                    // 请求成功，处理响应
                    var res = JSON.parse(that.xhr.responseText);
                    that.dataSet = res.data.records;
                    that.total = res.data.total;
                    that.pageIndex = res.data.current;
                    // 刷新筛选列表框
                    delete that.queryParamsModel.collectionRecordCount;
                }
                else {
                    // 请求失败，处理错误
                    console.error("Error: " + that.xhr.status);
                }
            }
        };
    };
    ;
    CollectionCase.prototype.getPercentage = function (runningTotal, total) {
        return (runningTotal / total) * 100;
    };
    ;
    CollectionCase.prototype.controlTask = function (row, action) {
        var that = this;
        var myObj = {
            taskId: row.taskId,
            action: action,
            customer: 'C284',
        };
        // 初始化 GET 请求
        that.xhr.open("POST", CallApi.callTaskControl, true);
        that.xhr.setRequestHeader("Content-Type", "application/json");
        // 发送 GET 请求
        that.xhr.send(JSON.stringify(myObj));
        // 定义处理响应的回调函数
        that.xhr.onreadystatechange = function () {
            that.loading.state = false;
            if (that.xhr.readyState === XMLHttpRequest.DONE) {
                if (that.xhr.status === 200) {
                    var res = JSON.parse(that.xhr.responseText);
                    if (res.status === 200) {
                        that.$message.success("操作成功");
                        that.refreshData();
                    }
                    else {
                        that.$message.error(res.message ? res.message : "服务器错误");
                    }
                }
                else {
                    // 请求失败，处理错误
                    console.error("Error: " + that.xhr.status);
                }
            }
        };
    };
    CollectionCase.prototype.gotoPhoneCase = function () {
        var that = this;
        var httpRequest = new XMLHttpRequest();
        httpRequest.open("GET", "https://ftapi.liansdk.com/trusteeship/yalt/getconnect?dst=" + StorageService.getItem("userInfoStage").agent, true); //第二步：打开连接  将请求参数写在url中  ps:"./Ptest.php?name=test&nameone=testone"
        httpRequest.send();
        httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState == 4 && httpRequest.status == 200) {
                var json4 = httpRequest.responseText;
                console.log(json4);
                if (1 == JSON.parse(json4).code) {
                    console.log("接通的电话：" + JSON.parse(json4).data.dst);
                    that.onBatchNumberClick2(JSON.parse(json4).data.pjid);
                }
            }
            else {
                //alert('没有接通')
            }
        };
    };
    CollectionCase.prototype.onBatchNumberClick2 = function (currentCollection) {
        var otherData = {
            sort: this.sortService.clone(),
            caseType: "TEL_CASE",
        };
        this.queryParamsModel.casePool = "INNER"; //在调案件池
        var data = new CollectionData(this.queryParamsModel.principalId, currentCollection, this.queryParamsModel, otherData);
        this.openExecutionPage(data);
    };
    __decorate([
        Dependencies(PageService)
    ], CollectionCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CollectionCase.prototype, "sortService", void 0);
    __decorate([
        Dependencies(StatusConfigService)
    ], CollectionCase.prototype, "statusConfigService", void 0);
    __decorate([
        Dependencies(CaseCollectorService)
    ], CollectionCase.prototype, "caseCollectorService", void 0);
    __decorate([
        collectionManageModule.Action
    ], CollectionCase.prototype, "openExecutionPage", void 0);
    __decorate([
        State
    ], CollectionCase.prototype, "principalList", void 0);
    __decorate([
        State
    ], CollectionCase.prototype, "collectorList", void 0);
    __decorate([
        Getter
    ], CollectionCase.prototype, "departmentData", void 0);
    __decorate([
        Watch("$route", {
            immediate: true,
        })
    ], CollectionCase.prototype, "onRouteChange", null);
    CollectionCase = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                FilterCollection: FilterCollection,
                FollowAllQuery: FollowAllQuery,
                NumberRange: NumberRange,
            },
        })
    ], CollectionCase);
    return CollectionCase;
}(Vue));
export default CollectionCase;
